import React, { useCallback, useState, useEffect } from "react";
import QueryTextInput from "./QueryTextInput";

function Form({ activeTab, onSearch, fieldErrors, searchActive }) {
  const [formValues, setFormValues] = useState({
    query: "",
  });

  const camelToUnderscore = (str) => str.replace(/([A-Z])/g, "_$1").toLowerCase();

  useEffect(() => {
    const updatedFormValues = {};

    if (activeTab === "promotional_opportunities") {
      updatedFormValues.searchModelTypes = ["Interact::Request"];
    } else if (activeTab === "resources_for_media") {
      updatedFormValues.searchModelTypes = ["Id::PromoEntity::Expert", "Interact::Pitch"];
    } else {
      // throw new Error("Should not happen!");
    }

    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      ...updatedFormValues,
    }));
  }, [activeTab]);

  // Run-once on mount: reads URL params to initialize form state.
  // Intentionally omits formValues from deps - we want initial values, not to re-run on every form change.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    setFormValues((prevFormValues) => {
      const updatedFormValues = {};

      Object.keys(prevFormValues).forEach((key) => {
        const underscoreKey = camelToUnderscore(key);
        const urlValue = urlParams.get(underscoreKey);
        if (urlValue !== null) {
          updatedFormValues[key] = Array.isArray(prevFormValues[key]) ? urlValue.split(",") : urlValue;
        }
      });

      return { ...prevFormValues, ...updatedFormValues };
    });
  }, []);

  const handleChange = (field, value) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [field]: value,
    }));
  };

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      onSearch(formValues);
    },
    [formValues, onSearch],
  );

  // Handling Cmd+Return or Ctrl+Enter to submit form
  useEffect(() => {
    function handleKeyDown(e) {
      if ((e.metaKey || e.ctrlKey) && e.keyCode === 13) {
        // metaKey for Mac, ctrlKey for others, keyCode 13 is Enter
        handleSubmit(new Event("submit")); // Create a new 'submit' event and pass it to handleSubmit
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [formValues, handleSubmit]); // Depend on formValues to ensure updated state is used

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <QueryTextInput
        value={formValues.query}
        onChange={(value) => handleChange("query", value)}
        error={fieldErrors.query}
      />
      <button type="submit" className="btn btn-primary" disabled={searchActive}>
        Search
      </button>
    </form>
  );
}

export default Form;
